// src/data/departments.js
import {
    faClipboard, faBuilding, faRoad, faPencilRuler, faMap,
    faGears, faNetworkWired, faBolt, faShieldAlt,
    faCode, faMobileAlt, faRobot, faDatabase, faCloud,
    faChartBar, faPaintBrush, faNewspaper, faChartLine, faGlobe
  } from '@fortawesome/free-solid-svg-icons';
  
  export const departmentsData = {
    informatique: {
      id: 'informatique',
      route: '/formation/informatique',
      titleKey: 'training_informatique_title',
      subtitleKey: 'training_informatique_subtitle',
      color: '#107a3e',
      heroBadgeKey: 'training_informatique_badge',
      breadcrumbLabelKey: 'training_informatique_breadcrumb',
      categoryKey: 'training_informatique_category',
      services: [
        {
          id: 1,
          titleKey: 'training_web_fullstack_title',
          descriptionKey: 'training_web_fullstack_desc',
          icon: faCode,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#107a3e',
          category: 'web'
        },
        {
          id: 2,
          titleKey: 'training_mobile_cross_title',
          descriptionKey: 'training_mobile_cross_desc',
          icon: faMobileAlt,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#107a3e',
          category: 'mobile'
        },
        {
          id: 3,
          titleKey: 'training_ai_title',
          descriptionKey: 'training_ai_desc',
          icon: faRobot,
          duration: '4',
          levelKey: 'training_level_advanced',
          color: '#107a3e',
          category: 'ai'
        },
        {
          id: 4,
          titleKey: 'training_cyber_title',
          descriptionKey: 'training_cyber_desc',
          icon: faShieldAlt,
          duration: '3',
          levelKey: 'training_level_advanced',
          color: '#107a3e',
          category: 'cyber'
        },
        {
          id: 5,
          titleKey: 'training_dba_title',
          descriptionKey: 'training_dba_desc',
          icon: faDatabase,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#107a3e',
          category: 'dba'
        },
        {
          id: 6,
          titleKey: 'training_cloud_title',
          descriptionKey: 'training_cloud_desc',
          icon: faCloud,
          duration: '3',
          levelKey: 'training_level_advanced',
          color: '#107a3e',
          category: 'cloud'
        },
      ],
    },
    electrique: {
      id: 'electrique',
      route: '/formation/electrique',
      titleKey: 'training_electrique_title',
      subtitleKey: 'training_electrique_subtitle',
      color: '#c8a02b',
      heroBadgeKey: 'training_electrique_badge',
      breadcrumbLabelKey: 'training_electrique_breadcrumb',
      categoryKey: 'training_electrique_category',
      services: [
        {
          id: 1,
          titleKey: 'training_auto_indus_title',
          descriptionKey: 'training_auto_indus_desc',
          icon: faGears,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#c8a02b',
          category: 'automation'
        },
        {
          id: 2,
          titleKey: 'training_smart_building_title',
          descriptionKey: 'training_smart_building_desc',
          icon: faBuilding,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#c8a02b',
          category: 'building'
        },
        {
          id: 3,
          titleKey: 'training_iot_title',
          descriptionKey: 'training_iot_desc',
          icon: faNetworkWired,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#c8a02b',
          category: 'iot'
        },
        {
          id: 4,
          titleKey: 'training_energy_title',
          descriptionKey: 'training_energy_desc',
          icon: faBolt,
          duration: '3',
          levelKey: 'training_level_advanced',
          color: '#c8a02b',
          category: 'energy'
        },
        {
          id: 5,
          titleKey: 'training_security_title',
          descriptionKey: 'training_security_desc',
          icon: faShieldAlt,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#c8a02b',
          category: 'security'
        },
      ],
    },
    civil: {
      id: 'civil',
      route: '/formation/civil',
      titleKey: 'training_civil_title',
      subtitleKey: 'training_civil_subtitle',
      color: '#0066cc',
      heroBadgeKey: 'training_civil_badge',
      breadcrumbLabelKey: 'training_civil_breadcrumb',
      categoryKey: 'training_civil_category',
      services: [
        {
          id: 1,
          titleKey: 'training_civil_studies_title',
          descriptionKey: 'training_civil_studies_desc',
          icon: faClipboard,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#0066cc',
          category: 'studies'
        },
        {
          id: 2,
          titleKey: 'training_civil_building_title',
          descriptionKey: 'training_civil_building_desc',
          icon: faBuilding,
          duration: '4',
          levelKey: 'training_level_advanced',
          color: '#0066cc',
          category: 'building'
        },
        {
          id: 3,
          titleKey: 'training_civil_public_title',
          descriptionKey: 'training_civil_public_desc',
          icon: faRoad,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#0066cc',
          category: 'public'
        },
        {
          id: 4,
          titleKey: 'training_civil_arch_title',
          descriptionKey: 'training_civil_arch_desc',
          icon: faPencilRuler,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#0066cc',
          category: 'arch'
        },
        {
          id: 5,
          titleKey: 'training_civil_topo_title',
          descriptionKey: 'training_civil_topo_desc',
          icon: faMap,
          duration: '3',
          levelKey: 'training_level_beginner',
          color: '#0066cc',
          category: 'topo'
        },
      ],
    },
    marketing: {
      id: 'marketing',
      route: '/formation/marketing',
      titleKey: 'training_marketing_title',
      subtitleKey: 'training_marketing_subtitle',
      color: '#6b3fa0',
      heroBadgeKey: 'training_marketing_badge',
      breadcrumbLabelKey: 'training_marketing_breadcrumb',
      categoryKey: 'training_marketing_category',
      services: [
        {
          id: 1,
          titleKey: 'training_marketing_strategy_title',
          descriptionKey: 'training_marketing_strategy_desc',
          icon: faChartBar,
          duration: '2',
          levelKey: 'training_level_intermediate',
          color: '#6b3fa0',
          category: 'strategy'
        },
        {
          id: 2,
          titleKey: 'training_marketing_digital_title',
          descriptionKey: 'training_marketing_digital_desc',
          icon: faMobileAlt,
          duration: '3',
          levelKey: 'training_level_intermediate',
          color: '#6b3fa0',
          category: 'digital'
        },
        {
          id: 3,
          titleKey: 'training_marketing_content_title',
          descriptionKey: 'training_marketing_content_desc',
          icon: faPaintBrush,
          duration: '2',
          levelKey: 'training_level_beginner',
          color: '#6b3fa0',
          category: 'content'
        },
        {
          id: 4,
          titleKey: 'training_marketing_press_title',
          descriptionKey: 'training_marketing_press_desc',
          icon: faNewspaper,
          duration: '2',
          levelKey: 'training_level_intermediate',
          color: '#6b3fa0',
          category: 'press'
        },
        {
          id: 5,
          titleKey: 'training_marketing_analytics_title',
          descriptionKey: 'training_marketing_analytics_desc',
          icon: faChartLine,
          duration: '2',
          levelKey: 'training_level_advanced',
          color: '#6b3fa0',
          category: 'analytics'
        },
        {
          id: 6,
          titleKey: 'training_marketing_international_title',
          descriptionKey: 'training_marketing_international_desc',
          icon: faGlobe,
          duration: '3',
          levelKey: 'training_level_advanced',
          color: '#6b3fa0',
          category: 'international'
        },
      ],
    },
  };
  
  export const departmentIds = Object.keys(departmentsData);